import type _GoPayEmbedScript from "@components/GoPayEmbedScript.svelte";
import type { GoPayData } from "@core/schema/GoPayData.js";
import type { GoPayPaymentState } from "@core/schema/GoPayPaymentState.js";
import type { GraphQLClient } from "@core/utils/aws/appsync/GraphQLClient.js";
import { checkPaymentStatus } from "./checkPaymentStatus.js";

/**
 * Opens the GoPay inline gateway, and returns the payment state.
 * Don't forget to include the {@link _GoPayEmbedScript GoPayEmbedScript}
 * in your page, otherwise the function will not work.
 *
 * @param goPayData
 */
export async function openGoPay(graphQL: GraphQLClient, goPayData: GoPayData): Promise<GoPayPaymentState> {
	if (typeof _gopay === "undefined") {
		throw new Error("GoPay was not initialized.");
	}
	const returnUrl = await new Promise<URL>((resolve) => {
		_gopay.checkout({ gatewayUrl: goPayData.url, inline: true }, (response) => {
			resolve(new URL(response.url));
		});
	});
	const id = new URLSearchParams(returnUrl.search).get("id");
	if (!id) {
		throw new Error("No payment ID found in return URL.");
	}
	return await checkPaymentStatus(graphQL, id);
}
